import React, { Component } from "react";
import WorkItem from "./WorkItem";
import Image from "../../assets/img/work/png/dekosupport.png";

class Deko extends Component {
  componentDidMount() {
    this.item.componentDidMount();
  }

  enterTransition = time => {
    this.item.enterTransition(time);
  };

  exitTransition = time => {
    this.item.exitTransition(time);
  };

  render = () => {
    return (
      <WorkItem
        ref={item => (this.item = item)}
        title="Deko Internal"
        description={`Management SPA (single page application) for glazed, mobile partitions and doors. Application also
        contains heavily integrated messaging module and enterprise level user management module. The greatest
        challenge was to keep a simple user experiance while solving all the complex product requirements for
        technical drawings, parametrization and related files. Our part: requirements analysis, backend and
        frontend development, automated testing.`}
        image={Image}
        iconList={["react", "redux", "php", "mysql"]}
      />
    );
  };
}

export default Deko;



// WEBPACK FOOTER //
// ./src/components/Work/DekoSupport.js